import clsx from 'clsx'
import styles from './UpdatedRecordsTable.module.scss'
import React from 'react'

interface Props {
    value: string | number | string[]
    updated: boolean
}

export const PrimitiveDefaultValue = React.memo(({ value, updated }: Props) => {
    const displayedValue = Array.isArray(value) ? value.join(', ') : value

    return (
        <div
            className={clsx(styles.updatedContainer, {
                [styles.updatedHighlighted]: updated,
            })}
        >
            {displayedValue || '-'}
        </div>
    )
})
